const router = [
  {
    path: '/mistForest',
    name: 'mistForest',
    component: () => import('@/views/setting/mistForest/Map.vue'),
    meta: {
      title: '雾森',
      hasBack: false
    }
  }
]

export default router
